module.exports = __webpack_public_path__ + "static/media/analytics.0d3a4e04.svg";